import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../app/stores/store";
import ArtistDetails from "../artists/ArtistDetails";

export default observer(function ArtistResults() {
  const {
    artistStore: { searching, searchResults, searchPagination },
    sidebarStore: { closeSidebar },
    modalStore: { openModal },
  } = useStore();

  const navigate = useNavigate();

  return (
    <>
      <Typography sx={{ pl: 2 }} variant="h6">
        Artists
      </Typography>

      {searching ? (
        <Box display={"flex"} justifyContent={"center"} mb={2}>
          <CircularProgress size={20} />
        </Box>
      ) : searchResults.length === 0 ? (
        <Typography pl={2} variant="subtitle1" gutterBottom>
          No results
        </Typography>
      ) : (
        <>
          <List>
            {searchResults.slice(0, 9).map((artist) => {
              return (
                <ListItemButton
                  key={artist.id}
                  onClick={() =>
                    openModal({
                      size: "sm",
                      content: <ArtistDetails id={artist.id} />,
                    })
                  }
                >
                  <ListItemAvatar>
                    <Avatar
                      alt={artist.name}
                      src={
                        artist.image
                          ? `${process.env.REACT_APP_RESOURCE_URL}${artist.image}`
                          : `/record_ph.png`
                      }
                      onError={(i: any) => (i.target.src = "/record_ph.png")}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={artist.name}
                    secondary={`${artist.recordsCount} records`}
                  />
                </ListItemButton>
              );
            })}
          </List>

          {!!searchPagination && searchPagination.totalItems > 10 && (
            <Box display={"flex"} justifyContent={"center"} mb={2}>
              <Button
                size="large"
                color="primary"
                variant="text"
                onClick={() => {
                  closeSidebar();
                  navigate("/artists/search");
                }}
              >
                {`Browse all ${searchPagination?.totalItems} Artists`}
              </Button>
            </Box>
          )}
        </>
      )}
    </>
  );
});
